import { connectLpAsyncEvents, connectVideoAnalyticsAsyncEvents } from '@vlabs/pages/point/workspace/store';
import { init as initVideoanalytics } from '@vlabs/pages/video-analytics/store';

export const initWSAfterAuth = (dispatch, getState) => {
  const { app: { features } } = getState();

  dispatch(connectLpAsyncEvents());

  if (features.components?.video_analytics) {
    dispatch(initVideoanalytics);
    dispatch(connectVideoAnalyticsAsyncEvents());
  }
};
